export default __webpack_public_path__ + "static/media/1.a08e8d1f.png";